<template>
  <AppTemplate>
    <template #title>Utilisateurs ({{ lines }})</template>
    <div class="card card-body p-2">
        <AsdecodeTable class="mb-4" :columns="columns" url="/api/utilisateurs" table="users" @set-total-records="updateLines"
            @row-click="showLine" @set-selected-rows="getSelection">

            <template #statut="slotProps">
                <span class="p-2 rounded-pill badge badge-primary">{{ slotProps.data.statut }}</span>
            </template>
        </AsdecodeTable>
    </div>
  </AppTemplate>
</template>

<script>
import { defineComponent } from 'vue';
import FormUser from './FormUser.vue';
import ShowUser from './ShowUser.vue';

export default defineComponent({
    name: 'IndexUser',

    data() {
        return {
            lines: 0,
            selection: [],
            columns: [
                {
                    key: 'name',
                    label: 'Nom d\'utilisateur',
                    sortable: true,
                    exportable: true,
                },
                {
                    key: 'email',
                    label: 'Adresse email',
                    sortable: true,
                    exportable: true,
                },
                {
                    key: 'role',
                    label: 'Role',
                },
                {
                    key: 'created_at',
                    label: 'Date d\'inscription',
                    format: 'datetime',
                }
            ]
        }
    },
    methods: {
        showLine(line) {
            this.$dialog.open(ShowUser, {
                props: {
                    header: 'Utilisateur ID'+line.id,
                    style: { width: '50vw' },
                    modal: true,
                },
                data: line
            });
        },
        updateLines(nb) {
            this.lines = nb
        },
        // getSelection(selection) {
        //     this.selection = selection
        // },
        showCreateModal() {
            this.$dialog.open(FormUser, {
                props: {
                    header: 'Ajouter un utilisateur',
                    style: { width: '50vw' },
                    modal: true,
                },

            });
        },
    },
});
</script>